module.exports = __webpack_public_path__ + "img/banner_h501.b6ba640d.webp";